export enum ClassifiedViewVariant {
  DEFAULT = 'default',
  MAP = 'map',
  DEALER_SITE = 'dealer-site'
}
